import { render, staticRenderFns } from "./clubWrapper.vue?vue&type=template&id=3d5c81d2"
import script from "./clubWrapper.vue?vue&type=script&lang=js"
export * from "./clubWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports